import { render, staticRenderFns } from "./PublicationEdit.vue?vue&type=template&id=fde2e574&scoped=true&"
import script from "./PublicationEdit.vue?vue&type=script&lang=js&"
export * from "./PublicationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde2e574",
  null
  
)

export default component.exports